export default "__VITE_ASSET__DbexgFFT__"